import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "bg-hero-gradient5 bottom-0 block left-0 absolute top-0 w-full lg:h-675px lg:left-2/4 lg:transform lg:-translate-x-2/4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "block pt-50% w-full sm:pt-80" }, null, -1)
const _hoisted_4 = { class: "content-wrap relative py-0 px-4 w-auto my-0 mx-auto text-left bg-black-background lg:w-950px" }
const _hoisted_5 = { class: "anime-page-wrapper overflow-visible" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, null, -1)
const _hoisted_7 = { class: "inline overflow-visible sm:flex sm:float-right" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, null, -1)
const _hoisted_9 = { class: "featured-anime-header mb-4 -mt-2 flex sm:block sm:w-2/6" }
const _hoisted_10 = { class: "anime-page-poster-wrap self-start order-2 overflow-visible w-2/6 min-w-120px sm:min-w-200px relative z-0" }
const _hoisted_11 = { class: "poster-container h-auto w-full rounded inline-block overflow-hidden shadow relative bg-black" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { class: "frame z-1 bg-clip-padding bg-frame-gradient bg-no-repeat bg-frame rounded-lg shadow-frame box-border block h-full left-0 overflow-hidden absolute right-0 top-0 whitespace-nowrap" }, null, -1)
const _hoisted_14 = { class: "anime-page-details self-center order-1 pr-4" }
const _hoisted_15 = { class: "anime-title text-2xl m-0 text-white font-garamond font-extrabold sm:hidden" }
const _hoisted_16 = { class: "release-year text-sm leading-5 mt-1.5 mb-1 uppercase tracking-wider sm:hidden" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, "·", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Studio ")
const _hoisted_19 = { class: "anime-studio text-base leading-5 mb-1 font-black capitalize sm:hidden" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "anime-score text-sm leading-5 mt-1.5 mb-1 uppercase tracking-wider" }, " Score ", -1)
const _hoisted_21 = { class: "anime-score text-base leading-5 m-0 font-black" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "anime-score text-sm leading-5 mt-1.5 mb-1 uppercase tracking-wider" }, " Ranking ", -1)
const _hoisted_23 = { class: "anime-score text-base leading-5 m-0 font-black" }
const _hoisted_24 = { class: "mobile-options sm:hidden" }
const _hoisted_25 = {
  key: 0,
  class: "anime-user-options flex justify-around"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">Lists</option><option value=\"watching\">Watching</option><option value=\"completed\">Completed</option><option value=\"on_hold\">On Hold</option><option value=\"dropped\">Dropped</option><option value=\"plan_to_watch\">Planned</option><option value=\"delete\">Delete</option>", 7)
const _hoisted_34 = [
  _hoisted_27
]
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">Score</option><option value=\"10\">10</option><option value=\"9\">9</option><option value=\"8\">8</option><option value=\"7\">7</option><option value=\"6\">6</option><option value=\"5\">5</option><option value=\"4\">4</option><option value=\"3\">3</option><option value=\"2\">2</option><option value=\"1\">1</option>", 11)
const _hoisted_47 = [
  _hoisted_36
]
const _hoisted_48 = { class: "episodes-watched text-left no-underline align-middle inline-block py-2 px-3 whitespace-nowrap bg-gray-button text-white border-none rounded shadow-profilePic h-10 font-bold w-full ml-2" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Eps: ")
const _hoisted_50 = ["value"]
const _hoisted_51 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_52 = { class: "m-0 p-0 whitespace-nowrap" }
const _hoisted_53 = {
  key: 1,
  class: "submit-anime-info-button w-full"
}
const _hoisted_54 = {
  key: 0,
  class: "anime-submit-message text-white text-sm py-1em px-2em border-none rounded inline-block no-underline tracking-wider uppercase w-full text-center"
}
const _hoisted_55 = { key: 2 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "anime-please-login-message text-white text-sm py-1em px-2em border-none rounded inline-block no-underline tracking-wider uppercase w-full text-center" }, " Please login to add anime to lists. ", -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "anime-synopsis float-none w-auto overflow-visible p-0 relative block sm:ml-10" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, null, -1)
const _hoisted_60 = { class: "block" }
const _hoisted_61 = { class: "mb-0 overflow-hidden text-base leading-6 font-garamond font-semibold" }
const _hoisted_62 = { class: "anime-title text-2xl m-0 text-white font-garamond font-extrabold h-full hidden sm:flex sm:items-center sm:m-0" }
const _hoisted_63 = { class: "flex items-center h-8" }
const _hoisted_64 = { class: "release-year text-sm leading-5 mt-1.5 mb-1 uppercase tracking-wider font-quicksand h-full hidden sm:flex sm:items-center sm:m-0 sm:text-base" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "bullet mx-3" }, "·", -1)
const _hoisted_66 = { class: "normal-options hidden font-quicksand sm:block mb-2 max-w-600px" }
const _hoisted_67 = {
  key: 0,
  class: "anime-user-options flex justify-around"
}
const _hoisted_68 = ["value"]
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">Lists</option><option value=\"watching\">Watching</option><option value=\"completed\">Completed</option><option value=\"on_hold\">On Hold</option><option value=\"dropped\">Dropped</option><option value=\"plan_to_watch\">Planned</option><option value=\"delete\">Delete</option>", 7)
const _hoisted_76 = [
  _hoisted_69
]
const _hoisted_77 = ["value"]
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<option value=\"0\">Score</option><option value=\"10\">10</option><option value=\"9\">9</option><option value=\"8\">8</option><option value=\"7\">7</option><option value=\"6\">6</option><option value=\"5\">5</option><option value=\"4\">4</option><option value=\"3\">3</option><option value=\"2\">2</option><option value=\"1\">1</option>", 11)
const _hoisted_89 = [
  _hoisted_78
]
const _hoisted_90 = { class: "episodes-watched text-left no-underline align-middle inline-block py-2 px-3 whitespace-nowrap bg-gray-button text-white border-none rounded shadow-profilePic h-10 w-full ml-2 font-bold" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Episodes: ")
const _hoisted_92 = ["value"]
const _hoisted_93 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_94 = { class: "m-0 p-0 whitespace-nowrap" }
const _hoisted_95 = {
  key: 1,
  class: "submit-anime-info-button w-full"
}
const _hoisted_96 = {
  key: 0,
  class: "anime-submit-message text-white text-sm py-1em px-2em border-none rounded inline-block no-underline tracking-wider uppercase w-full text-center"
}
const _hoisted_97 = { key: 2 }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("p", { class: "anime-please-login-message text-white text-sm py-1em px-2em border-none rounded inline-block no-underline tracking-wider uppercase w-full text-center" }, " Please login to add anime to lists. ", -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("h4", { class: "-mt-1 font-quicksand tracking-widest uppercase font-normal mb-1" }, " Synopsis ", -1)
const _hoisted_101 = {
  key: 0,
  class: "short-synopsis block flex sm:hidden"
}
const _hoisted_102 = {
  key: 1,
  class: "full-synopsis block hidden sm:hidden"
}
const _hoisted_103 = {
  key: 2,
  class: "full-synopsis block sm:hidden"
}
const _hoisted_104 = { class: "full-synopsis block hidden sm:block max-w-600px" }
const _hoisted_105 = {
  key: 1,
  class: "min-v-screen min-h-screen flex items-center justify-center"
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_107 = [
  _hoisted_106
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Backdrop = _resolveComponent("Backdrop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    (_ctx.anime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Backdrop, {
            animeBackground: _ctx.anime.main_picture.large
          }, null, 8, ["animeBackground"]),
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("section", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          class: "h-auto w-full rounded block",
                          src: _ctx.anime.main_picture.medium,
                          alt: _ctx.anime.title
                        }, null, 8, _hoisted_12),
                        _hoisted_13
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.anime.title), 1),
                    _createElementVNode("p", _hoisted_16, [
                      _createElementVNode("a", null, _toDisplayString(`${_ctx.anime.start_season.year} `), 1),
                      _hoisted_17,
                      _hoisted_18
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.anime.studios[0].name), 1),
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.anime.mean), 1),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.anime.rank), 1)
                  ])
                ]),
                _createElementVNode("section", _hoisted_24, [
                  (_ctx.user)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                        _createElementVNode("select", {
                          name: "Lists",
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeList($event))),
                          class: "form-control text-center flex justify-between w-full mr-2 whitespace-nowrap bg-gray-button text-white border-none rounded shadow-profilePic font-bold",
                          value: _ctx.listValue || '0'
                        }, _hoisted_34, 40, _hoisted_26),
                        _createElementVNode("select", {
                          name: "Score",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeScore($event))),
                          class: "form-control text-center flex justify-between w-full mx-2 whitespace-nowrap bg-gray-button text-white border-none rounded shadow-profilePic font-bold",
                          value: _ctx.scoreValue || '0'
                        }, _hoisted_47, 40, _hoisted_35),
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("input", {
                            type: "text",
                            name: "watched-episodes",
                            id: "watched-episodes",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeEpisode($event))),
                            class: "w-10 bg-gray-button text-right mr-1 font-bold",
                            value: _ctx.episodeValue || null
                          }, null, 40, _hoisted_50),
                          _hoisted_51,
                          _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.anime.num_episodes), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.user)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_53, [
                        _createElementVNode("button", {
                          class: "text-center py-2 px-3 w-full visible whitespace-nowrap uppercase bg-gray-button text-white border-none rounded shadow-profilePic tracking-wide font-bold mt-3",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitAnimeInfo && _ctx.submitAnimeInfo(...args)))
                        }, " Submit "),
                        (_ctx.submitMessage)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.submitMessage), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.user)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_55, _hoisted_57))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("section", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h1", _hoisted_62, _toDisplayString(_ctx.anime.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("p", _hoisted_64, [
                          _createElementVNode("a", null, _toDisplayString(`${_ctx.anime.start_season.year} `), 1),
                          _hoisted_65,
                          _createTextVNode(" " + _toDisplayString(_ctx.anime.studios[0].name), 1)
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_66, [
                        (_ctx.user)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_67, [
                              _createElementVNode("select", {
                                name: "Lists",
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeList($event))),
                                class: "form-control text-center flex justify-between w-full mr-2 whitespace-nowrap bg-gray-button text-white border-none rounded shadow-profilePic font-bold",
                                value: _ctx.listValue || '0'
                              }, _hoisted_76, 40, _hoisted_68),
                              _createElementVNode("select", {
                                name: "Score",
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeScore($event))),
                                class: "form-control text-center flex justify-between w-full mx-2 whitespace-nowrap bg-gray-button text-white border-none rounded shadow-profilePic font-bold",
                                value: _ctx.scoreValue || '0'
                              }, _hoisted_89, 40, _hoisted_77),
                              _createElementVNode("div", _hoisted_90, [
                                _hoisted_91,
                                _createElementVNode("input", {
                                  type: "text",
                                  name: "watched-episodes",
                                  id: "watched-episodes",
                                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeEpisode($event))),
                                  class: "w-12 bg-gray-button text-right mr-1 font-bold",
                                  value: _ctx.episodeValue || null
                                }, null, 40, _hoisted_92),
                                _hoisted_93,
                                _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.anime.num_episodes), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.user)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_95, [
                              _createElementVNode("button", {
                                class: "text-center py-2 px-3 w-full visible whitespace-nowrap uppercase bg-gray-button text-white border-none rounded shadow-profilePic tracking-wide font-bold mt-3",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitAnimeInfo && _ctx.submitAnimeInfo(...args)))
                              }, " Submit "),
                              (_ctx.submitMessage)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString(_ctx.submitMessage), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.user)
                          ? (_openBlock(), _createElementBlock("section", _hoisted_97, _hoisted_99))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_100,
                      (_ctx.anime.synopsis.length > 200)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.anime.synopsis.substring(0, 200)) + " ", 1),
                              _createElementVNode("button", {
                                class: "font-black text-gray-text2",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleSynopsis && _ctx.toggleSynopsis(...args)))
                              }, " ...more ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.anime.synopsis.length > 200)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.anime.synopsis) + " ", 1),
                              _createElementVNode("button", {
                                class: "font-black text-gray-text2",
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleSynopsis && _ctx.toggleSynopsis(...args)))
                              }, " ...less ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.anime.synopsis.length < 200)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.anime.synopsis), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.anime.synopsis), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_105, _hoisted_107))
  ], 64))
}